"use client";

import { useSearchActive } from "../../../helpers/SearchActiveContext";
import type { ReactNode } from "react";

/**
 * Wraps a region of the support-hub layout that should become `inert` while
 * the Typesense search modal is open. Used for the desktop side menu, which
 * stays interactive while the question detail modal is open but freezes
 * during search.
 */
export function InertWhenSearchModalOpen({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { isSearchModalOpen } = useSearchActive();
  return (
    <div className={className} inert={isSearchModalOpen || undefined}>
      {children}
    </div>
  );
}

/**
 * Wraps a region that should become `inert` while ANY support-hub modal is
 * open (search or question detail). Used for the main content and the
 * footer.
 */
export function InertWhenAnyModalOpen({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { isSearchModalOpen, isQuestionModalOpen } = useSearchActive();
  const isAnyOpen = isSearchModalOpen || isQuestionModalOpen;
  return (
    <div className={className} inert={isAnyOpen || undefined}>
      {children}
    </div>
  );
}
